import React, { useEffect } from "react";
import { BASE_URL, DOMAIN } from "./../../global";
import Tables from "../../utils/components/tables";
import moment from "moment";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import {
  Button,
  TableContainer,
  Toolbar,
  TextField,
  Autocomplete,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { showComponent } from "../helper/helpers";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import axiosWithToken from "../../utils/components/axiosTokenConfig";

var columns = [
  {
    id: "id",
    label: "Sr. No.",
    align: "left",
    minWidth: 40,
  },
    {
    id: "clientName",
    label: "Client Name",
    align: "left",
    minWidth: 40,
  },
  {
    id: "transformerCapacity",
    label: "Transformer Capacity",
    align: "left",
    minWidth: 40,
  },
  {
    id: "name",
    label: "Name of Part",
    align: "left",
    minWidth: 40,
  },
  {
    id: "siNo",
    label: "SI No.",
    align: "left",
    minWidth: 40,
  },
  {
    id: "hsnCode",
    label: "HSN Code",
    align: "left",
    minWidth: 40,
  },
  {
    id: "rate",
    label: "Rate",
    align: "left",
    minWidth: 40,
  },
];

const ServiceList = () => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [searchBy, setSearchBy] = React.useState("");
  const [searchKey, setSearchKey] = React.useState("");
  const [totalRows, setTotalRows] = React.useState(0);
  const _clientId = localStorage.getItem("clientId");
  const _userType = localStorage.getItem("type");
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const [data, setFinalData] = React.useState([]);
  const [clientList, setClientList] = React.useState([]);
  const [selectedClient, setSelectedClient] = React.useState(null);

  const getQuery = (count) => {
    let whereConditions = "";
    let pagination_settings = "";

    if (searchBy !== "" && searchKey != "") {
      let colName = {
        "Transformer Capacity": "tt.transformerCapacity",
        "Name of Part": "pm.name",
      }[searchBy];
      whereConditions = `where ${colName} like '%${searchKey}%'`;
    }

    if (_userType == 3)
      whereConditions +=
        whereConditions.length > 0
          ? ` and tt.clientId = ${_clientId}`
          : ` where tt.clientId = ${_clientId}`;

    if (selectedClient) {
      whereConditions +=
        whereConditions.length > 0
          ? ` and tt.clientId = ${selectedClient}`
          : ` where tt.clientId = ${selectedClient}`;
    }

    if (rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }

   let data = { query: `SELECT ps.*, pm.name, tt.transformerCapacity, clients.name AS clientName FROM partsAndServices ps LEFT JOIN parts pm ON ps.partId = pm.id LEFT JOIN transformerTypes tt ON ps.transformerId = tt.id LEFT JOIN clients ON tt.clientId = clients.id ${whereConditions} ORDER BY ps.id DESC ${pagination_settings}` };


    if (count)
      data.query = `SELECT COUNT(*) AS no_of_rows  FROM partsAndServices ps LEFT JOIN parts pm ON ps.partId = pm.id LEFT JOIN transformerTypes tt ON ps.transformerId = tt.id LEFT JOIN clients ON tt.clientId = clients.id ${whereConditions}`;
    return data;
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
      });
  }

  function fetchFinalData() {
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setFinalData(res.data);
      })
      .catch((err) => {
        console.log("  error: ", err);
      });
  }

  const search = () => {
    fetchFinalData();
  };

  const handleDelete = (id) => {
    let url = BASE_URL;
    axiosWithToken
      .delete(url + `partsAndServices/${id}`)
      .then((res) => {
        toast("Service is deleted!");
        setTimeout(refresh, 500);
      })
      .catch((error) => {
        toast.error("Something Went Wrong!");
      });
  };

  const fetchClients = () => {
    let url = BASE_URL;
    let SQLQuery = { query: "SELECT id, name FROM clients" };

    axiosWithToken
      .post(url + `dynamic`, SQLQuery)
      .then((res) => {
        setClientList(res.data);
      })
      .catch((error) => {
        console.log("Error fetching clients: ", error);
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    getTotalRows();
    fetchClients();
  }, []);

  useEffect(() => {
    fetchFinalData();
  }, [rowsPerPage, page]);

  const actions = [
    {
      id: "edit",
      tooltip: "Edit Service",
      link: true,
      linkTo: (row) => `/editService/${row.id}`,
      icon: <PreviewIcon />,
    },
    {
      id: "delete",
      tooltip: "Delete Service",
      icon: <DeleteIcon style={{ color: "#dc3545" }} />,
      handler: (row) =>
        window.confirm("Are you sure you want to delete this?") &&
        handleDelete(row?.id),
    },
  ];

  return (
    <div>
      <TableContainer component={Paper} sx={{ mt: 2, p: 2 }}>
        <Toolbar>
          {showComponent("add") && (
            <Button
              variant="contained"
              size="small"
              component={Link}
              to="/editService"
            >
              <b>ADD NEW</b>
            </Button>
          )}
        </Toolbar>
        <br />
        <div
          className="mb-2"
          style={{
            display: "flex",
            float: "left",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <div
            className="mb-2"
            style={{
              display: "flex",
              float: "left",
              justifyContent: "flex-end",
            }}
          >
            <Autocomplete
              sx={{
                m: 0,
                minWidth: 210,
                marginLeft: "10px",
              }}
              size="small"
              id="combo-box-demo"
              options={
                _userType == 3
                  ? clientList?.filter((client) => client.id == _clientId)
                  : clientList
              }
              getOptionLabel={(option) => option.name || ""}
              onChange={(event, newValue) => {
                setSelectedClient(newValue ? newValue.id : null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Client"
                  variant="outlined"
                />
              )}
            />

            <Autocomplete
              sx={{
                m: 0,
                minWidth: 180,
                marginLeft: "10px",
              }}
              size="small"
              id="combo-box-demo"
              options={
                _userType != 3
                  ? [
                      {
                        key: "tt.transformerCapacity",
                        label: "Transformer Capacity",
                      },
                      { key: "pm.name", label: "Name of Part" },
                    ]
                  : [
                      {
                        key: "tt.transformerCapacity",
                        label: "Transformer Capacity",
                      },
                    ]
              }
              renderInput={(params) => (
                <TextField {...params} label="Search By" />
              )}
              onInputChange={(event, newInputValue) => {
                setSearchBy(newInputValue);
              }}
            />
            <TextField
              id="outlined-basic"
              label={"enter " + searchBy}
              size="small"
              variant="outlined"
              onChange={(e) => setSearchKey(e.target.value)}
            />
            <Button
              variant="contained"
              size="small"
              sx={{ m: 0 }}
              style={{ marginLeft: "10px" }}
              onClick={() => {
                search();
              }}
            >
              <SearchIcon />
            </Button>
          </div>
        </div>
        <br />
        <Tables
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          handleDelete={handleDelete}
          columns={columns}
          finalData={data}
          actions={actions}
          totalRows={totalRows}
        />
      </TableContainer>
    </div>
  );
};

export default ServiceList;
